// @flow

import {havePermission} from "./utils"

export default class OrderSettingsPermissions {

  canRead(proRole: ProRole = null): boolean {
    return havePermission(
      'order.settings',
      proRole
    );
  }

  canEdit(proRole: ProRole = null): boolean {
    return havePermission(
      'order.settings.canEditSettings',
      proRole
    );
  }

  canEditOpeningHours(proRole: ProRole = null): boolean {
    return havePermission(
      'order.settings.canEditOpeningHours',
      proRole
    );
  }

  canEditMenuManagedByPos(proRole: ProRole = null): boolean {
    return havePermission(
      'order.settings.canEditMenuManagedByPos',
      proRole
    );
  }

}
